<template>
	<div id="page-wrapper" style="height:100%">
	    <section id="content" style="height:100%">
          <section class="hbox stretch" style="height:100%">
              <aside class="aside-xl b-l b-r" id="note-list">
                <section class="vbox flex">
                  <header class="header clearfix">
                    <span class="pull-right m-t">
                    <el-tooltip class="item" effect="dark" :content="$t('notes.new')" placement="top">
                    	<button class="btn btn-success btn-sm btn-icon" 
                    	style="margin-top:10px" 
                    	@click="createNew"
                    	:disabled="canNew"><i class="fa fa-plus"></i></button>
                    </el-tooltip>
                    </span>
                    <p class="h3">{{ $t('notes.title') }}</p>
                    <div class="input-group m-t m-b" style="width:100%">
                      <el-input :placeholder="$t('notes.keyword-ph')" size="medium" v-model="keyword">
                      	<el-button slot="append" size="medium" icon="el-icon-search" @click="searchNote"></el-button>
  					  </el-input>
                    </div>
                  </header>
                  <section>
                    <section>
                      <section>
                        <div class="padder">
                          <ul id="note-items" class="list-group">
                          	<li class="list-group-item hover" 
                          		v-for="n in filteredNotes"
                          		:class="{ active: n.id == currentNote.id }"
                          		@click="selectNote(n)">
                              <div class="view">
                              	<el-popconfirm
								  :title="$t('notes.confirm')"
								  :confirmButtonText="$t('notes.yes')"
  								  :cancelButtonText="$t('notes.no')"
  								  @onConfirm="deleteNote(n.id)"
								>
                                <button slot="reference" class="destroy close hover-action">×</button>
                                </el-popconfirm>
                                <div class="note-name text-ellipsis">
                                  <strong>
                                  {{ n.note != '' ? n.note.split('\n')[0] : $t('notes.new') }}
                                  </strong>
                                </div>
                                <div class="note-desc text-ellipsis">
                                  {{ n.note.split('\n').length > 1 ? n.note.split('\n')[1] : $t('notes.empty') }}
                                </div>
                                <span class="text-xs text-muted">{{ n.date }}</span>
                              </div>
                            </li>
                          </ul>
                            
                          <p class="text-center">&nbsp;</p>
                        </div>
                      </section>
                    </section>
                  </section>
                </section>
              </aside>
              <aside id="note-detail">
                  <section class="vbox">
                    <header class="header bg-light lter">
                      <p>{{ $t('notes.create', { date: currentNote.date }) }} </p>
                    </header>
                    <section class="scrollable bg-light lter paper">
                      <textarea type="text" class="form-control scrollable" :placeholder="$t('notes.input')" v-model="currentNote.note"></textarea>
                    </section>
                  </section>
                </aside>
          </section>
          <a href="#" class="hide nav-off-screen-block" data-toggle="class:nav-off-screen,open" data-target="#nav,html"></a>
        </section>
    </div>
</template>
<style scoped>
div#page-wrapper {
	height: 100%
}
.list-group {
  border-radius: 2px;
}
.list-group.no-radius .list-group-item {
  border-radius: 0 !important;
}
.list-group.no-borders .list-group-item {
  border: none;
}
.list-group.no-border .list-group-item {
  border-width: 1px 0;
}
.list-group.no-bg .list-group-item {
  background-color: transparent;
}
.list-group-item {
  border-color: #eaeef1;
  padding-right: 15px;
}
a.list-group-item:hover,
a.list-group-item:focus {
  background-color: #f9fafc;
}
.list-group-item.media {
  margin-top: 0;
}
.list-group-item.active {
  color: #fff;
  border-color: #1ccacc !important;
  background-color: #1ccacc !important;
}
.list-group-item.active .text-muted {
  color: #91eff0;
}
.list-group-item.active a {
  color: #fff;
}
.list-group-alt .list-group-item:nth-child(2n+2) {
  background-color: rgba(0,0,0,0.02) !important;
}
.list-group-lg .list-group-item {
  padding-top: 15px;
  padding-bottom: 15px;
}
.list-group-sp .list-group-item {
  margin-bottom: 5px;
  border-radius: 3px;
}
.list-group-item > .badge {
  margin-right: 0;
}
.list-group-item > .fa-chevron-right {
  float: right;
  margin-top: 4px;
  margin-right: -5px;
}
.list-group-item > .fa-chevron-right + .badge {
  margin-right: 5px;
}
.header,
.footer {
  min-height: 50px;
  padding: 0 15px;
}
.header > p,
.footer > p {
  margin-top: 15px;
  display: inline-block;
}
.header > .btn,
.header > .btn-group,
.header > .btn-toolbar,
.footer > .btn,
.footer > .btn-group,
.footer > .btn-toolbar {
  margin-top: 10px;
}
.header > .btn-lg,
.footer > .btn-lg {
  margin-top: 0;
}
.app .hbox.stretch {
    height: 100%;
  }
  .app .vbox > section,
  .app .vbox > footer {
    position: absolute;
  }
  .app .vbox.flex > section > section {
    overflow: auto;
  }
  .hbox {
    display: table;
    table-layout: fixed;
    border-spacing: 0;
    width: 100%;
  }
  .hbox > aside,
  .hbox > section {
    display: table-cell;
    vertical-align: top;
    height: 100%;
    float: none;
  }
  .hbox > aside.show,
  .hbox > aside.hidden-sm,
  .hbox > section.show,
  .hbox > section.hidden-sm {
    display: table-cell !important;
  }
  .vbox {
    display: table;
    border-spacing: 0;
    position: relative;
    height: 100vh;
    width: 100%;
  }
  .vbox > section,
  .vbox > footer {
    top: 0;
    bottom: 0;
    width: 100%;
  }
  .vbox > header ~ section {
    top: 0px;
  }
  .vbox > header.header-md ~ section {
    top: 60px;
  }
  .vbox > section.w-f {
    bottom: 50px;
  }
  .vbox > section.w-f-md {
    bottom: 60px;
  }
  .vbox > footer {
    top: auto;
    z-index: 1000;
  }
  .vbox.flex > header,
  .vbox.flex > section,
  .vbox.flex > footer {
    position: inherit;
  }
  .vbox.flex > section {
    display: table-row;
    height: 100%;
  }
  .vbox.flex > section > section {
    position: relative;
    height: 100%;
    -webkit-overflow-scrolling: touch;
  }
  .ie .vbox.flex > section > section {
    display: table-cell;
  }
  .vbox.flex > section > section > section {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .aside-xs {
    width: 60px;
  }
  .aside-sm {
    width: 150px;
  }
  .aside {
    width: 200px;
  }
  .aside-md {
    width: 240px;
  }
  .aside-lg {
    width: 300px;
  }
  .aside-xl {
    width: 360px;
  }
  .aside-xxl {
    width: 720px;
  }
  .header-md {
    min-height: 60px;
  }
  .header-md .navbar-form {
    margin-top: 15px;
    margin-bottom: 15px;
  }
.bg-light {
  background-color: #f2f4f8;
  color: #788288;
}
.bg-light.lt,
.bg-light .lt {
  background-color: #f7f8fb;
}
.bg-light.lter,
.bg-light .lter {
  background-color: #fcfcfd;
}
.bg-light.dk,
.bg-light .dk {
  background-color: #e9edf4;
}
.bg-light.dker,
.bg-light .dker {
  background-color: #e0e6f0;
}
.bg-light.bg,
.bg-light .bg {
  background-color: #f2f4f8;
}
/*List hover*/
.list-group-item{border-color:#e4e9ed;}
.list-group-item .fa-chevron-right{float: right;margin-top: 4px;margin-right: -5px}
.list-group-item > .fa-chevron-right + .badge {margin-right: 5px;}
li.list-group-item:hover, a.list-group-item:focus, a.list-group-item:active {background-color: #f1f5f9;}
li.list-group-item.active{background-color: #e1e5e9;border-color:#e1e5e9;color: #3a5a7a}
li.list-group-item.active > .badge, .nav-pills > .active > a > .badge{color: #3a5a7a}
.list-group-item.active a, .list-group-item.active .text-muted{color: #fff}
.list-group-item.active{background-color: #5191d1;border-color:#5191d1;}
.list-group-item.media{margin-top: 0}
.paper {
  position: relative;
  background: -webkit-linear-gradient(top,#f0f0f0 0%,white 5%) 0 0;
  background: -moz-linear-gradient(top,#f0f0f0 0%,white 5%) 0 0;
  background: linear-gradient(top,#f0f0f0 0%,white 5%) 0 0;
  -webkit-background-size: 100% 30px;
  -moz-background-size: 100% 30px;
  -ms-background-size: 100% 30px;
  background-size: 100% 30px;
}
.paper:before {
  content: '';
  position: absolute;
  width: 0px;
  top: 0;
  left: 39px;
  bottom: 0;
  border-left: 1px solid #1ccacc;
}
.paper textarea {
  border: none;
  background-color: transparent;
  height: 100vh;
  padding: 30px 0 0 55px;
  line-height: 30px;
  min-height: 210px;
}
.padder {
  padding-left: 15px;
  padding-right: 15px;
}
.padder-v {
  padding-top: 15px;
  padding-bottom: 15px;
}
.no-padder {
  padding: 0 !important;
}
.btn {
  font-weight: 500;
  border-radius: 2px;
}
.btn-icon {
  padding-left: 0 !important;
  padding-right: 0 !important;
  width: 34px;
  text-align: center;
}
.btn-icon.b-2x {
  width: 36px;
}
.btn-icon.btn-sm {
  width: 30px;
}
.btn-icon.btn-sm.b-2x {
  width: 32px;
}
.btn-icon.btn-lg {
  width: 45px;
}
.btn-icon.btn-lg.b-2x {
  width: 47px;
}
.btn-group-justified {
  border-collapse: separate;
}
.btn-rounded {
  border-radius: 50px;
  padding-left: 15px;
  padding-right: 15px;
}
.btn-rounded.btn-lg {
  padding-left: 25px;
  padding-right: 25px;
}
.btn > i.pull-left,
.btn > i.pull-right {
  line-height: 1.428571429;
}
.btn-block {
  padding-left: 12px;
  padding-right: 12px;
}
.btn-group-vertical > .btn:first-child:not(:last-child) {
  border-top-right-radius: 2px;
}
.btn-group-vertical > .btn:last-child:not(:first-child) {
  border-bottom-left-radius: 2px;
}
.btn-inactive {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.text-ellipsis {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<script>
import moment from 'moment'

export default {
  name: 'Notes',
  data: function() {
	return {
	  keyword: null,
	  currentNote: 1,
	  notes: []
	}
  },
  watch: {
    currentNote: {
    	handler: function(val, old) {
      		if (val.id != old.id) {
      		  //save old
      		  let that = this,
      		      userId = localStorage.getItem('token')
      		  old.userId = userId
      		  this.$http.post(this.API3_PREFIX + 'note', old).then(function (response) {
      		    console.log(response.data.id)
				if (old.id == null) {
				  old.id = response.data.id
				}
		      }).catch(function (error) {
				console.log(error)
		      })
      		}
      	},
      	deep: true
    }
  },
  computed: {
    filteredNotes: function() {
      let k = this.keyword ? this.keyword.toLowerCase() : ''
      if (!this.notes) return []
      return this.notes.filter(item => {
		if (item.note.toLowerCase().includes(k) || item.date.toString().includes(k)) {
		  return item
		}
	  })
    },
    canNew: function() {
      for (let i = 0; i < this.notes.length; i ++) {
        if (this.notes[i].id == null) return true
      }
      return false
    }
  },
  methods: {
    selectNote: function(note) {
      this.currentNote = note
      this.note = note.note
    },
    createNew: function() {
      this.notes.unshift({
      	'id': null,
      	'note': '',
      	'date': moment().format('YYYY-MM-DD HH:mm:ss')
      })
      this.currentNote = this.notes[0]
    },
    deleteNote: function(nid) {
        //console.log(nid)
    	if (nid == null) {
    	  //TO DO
    	} else {
          let d = {
            'userId': localStorage.getItem('token'),
            'ids': [],
            'source': 'notes'
          },
          that = this
	      d['ids'].push(nid)
          this.$http.post(this.API3_PREFIX + 'del_records', d).then(function (response) {
	        that.$message({
	          message: that.$t('notes.delete-success'),
	          type: 'success'
	        })
            for (let i = 0; i < that.notes.length; i ++) {
	          if (that.notes[i].id == nid)
	            that.notes.splice(i,1)
            }
          }).catch(function (error) {
            console.log(error)
            that.$message({
              message: that.$t('notes.delete-failed'),
              type: 'error'
            })
          })
    	}
    },
    searchNote: function() {
      let k = this.keyword
    },
    loadData: function() {
      let that = this,
          query = '?userId=' + localStorage.getItem('token')

	  this.$http.get(this.API3_PREFIX + 'notes' + query).then(function (response) {
		that.notes = response.data
		if (that.notes.length > 0)
		  that.currentNote = that.notes[0]
		else
		  that.createNew()
      }).catch(function (error) {
		console.log(error)
      })
    }
  },
  beforeDestroy: function() {
      let that = this,
		  userId = localStorage.getItem('token')
      this.currentNote.userId = userId
      console.log(this.currentNote)
      this.$http.post(this.API3_PREFIX + 'note', this.currentNote).then(function (response) {
		if (that.currentNote.id == null) {
		  that.currentNote.id = response.data.id
		}
	  }).catch(function (error) {
		console.log(error)
	  })
  },
  created: function() {
    this.loadData()
  }
}
</script>